import React from "react"

import { Spinner } from "../Spinner/Spinner"
import { loadingWrapper } from "./CarouselLoader.css"

export const CarouselLoader = () => (
  <div data-testid="carousel-loader" className={loadingWrapper}>
    <Spinner type="componentLevel" />
  </div>
)
